export default __webpack_public_path__ + "static/media/monitor-pc.ce7e29b7.png";